'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _addClass = require('../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _debounce = require('../helpers/util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _hasClass = require('../helpers/dom/has-class');

var _hasClass2 = _interopRequireDefault(_hasClass);

var _outerWidth = require('../helpers/dom/outer-width');

var _outerWidth2 = _interopRequireDefault(_outerWidth);

var _offset = require('../helpers/dom/offset');

var _offset2 = _interopRequireDefault(_offset);

var _breakpoint = require('../helpers/dom/breakpoint');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # PanelCarousel
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Panel Carousel, as used in KPI, summary bar.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * unofficial component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/panel-carousel.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var PanelCarousel = function (_BaseComponent) {
  _inherits(PanelCarousel, _BaseComponent);

  /**
   * PanelCarousel constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function PanelCarousel(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PanelCarousel);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    if (!el) {
      return _possibleConstructorReturn(_this);
    }

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    _this._initCarousel();
    return _this;
  }

  /**
   * Creates the carousel controls.
   */


  PanelCarousel.prototype._addControls = function _addControls() {
    this._forwards = document.createElement('div');
    (0, _addClass2.default)(this._forwards, 'spark-panel-carousel__forwards');
    this._forwards.innerHTML = '<button type="button" aria-label=' + this.nextLabel + '><i class="spark-icon-arrow-chevron-right spark-icon--fill"></i></button>';

    this._backwards = document.createElement('div');
    (0, _addClass2.default)(this._backwards, 'spark-panel-carousel__backwards');
    this._backwards.innerHTML = '<button type="button" aria-label=' + this.previousLabel + '><i class="spark-icon-arrow-chevron-left spark-icon--fill"></i></button>';

    this.el.appendChild(this._backwards);
    this.el.appendChild(this._forwards);

    if (this._hasTabs === true) {
      this._forwards.querySelector('button').setAttribute('tabIndex', -1);
      this._backwards.querySelector('button').setAttribute('tabIndex', -1);
      this._panelCarouselList.addEventListener('click', this._onTabListClickBound);
    }

    (0, _addClass2.default)(this._backwards, 'spark-panel-carousel__limit');
  };

  /**
   * Remove event listeners
   */


  PanelCarousel.prototype._removeEventListeners = function _removeEventListeners() {
    this._forwards.removeEventListener('click', this._onControlClickBound);
    this._backwards.removeEventListener('click', this._onControlClickBound);
    this._panelCarouselList.removeEventListener('touchstart', this._onMoveStartBound);
    this.el.removeEventListener('mousedown', this._onMoveStartBound);
    this._panelCarouselList.removeEventListener('keyup', this._onKeyUpBound);
    window.removeEventListener('scroll', this._onScrollBound);
    window.removeEventListener('resize', this._onResizeBound);
  };

  /**
   * Bind and add Carousel listeners
   */


  PanelCarousel.prototype._addCarouselListeners = function _addCarouselListeners() {
    this._onKeyUpBound = this._onKeyUp.bind(this);
    this._onControlClickBound = this._onControlClick.bind(this);
    this._onMoveStartBound = this._onMoveStart.bind(this);
    this._onMoveBound = this._onMove.bind(this);
    this._onMoveEndBound = this._onMoveEnd.bind(this);

    this._forwards.addEventListener('click', this._onControlClickBound);
    this._backwards.addEventListener('click', this._onControlClickBound);
    this._panelCarouselList.addEventListener('touchstart', this._onMoveStartBound);
    this.el.addEventListener('mousedown', this._onMoveStartBound);
    this._panelCarouselList.addEventListener('keyup', this._onKeyUpBound);
  };

  /**
   * Remove Carousel listeners
   */


  PanelCarousel.prototype._removeCarouselListeners = function _removeCarouselListeners() {
    this._forwards.removeEventListener('click', this._onControlClickBound);
    this._backwards.removeEventListener('click', this._onControlClickBound);
    this.el.removeEventListener('mousedown', this._onMoveStartBound);
    this._panelCarouselList.removeEventListener('keyup', this._onKeyUpBound);
  };

  /**
   * Add move listeners.
   * @param {Event} _event either a TouchEvent or a MouseEvent
   */


  PanelCarousel.prototype._addMoveListeners = function _addMoveListeners(_event) {
    if (_event.touches) {
      this._panelCarouselList.addEventListener('touchmove', this._onMoveBound);
      this._panelCarouselList.addEventListener('touchend', this._onMoveEndBound);
    } else {
      window.addEventListener('mouseup', this._onMoveEndBound);
      window.addEventListener('mousemove', this._onMoveBound);
    }
  };

  /**
   * Remove move listeners
   * @param  {Event} _event MouseEvent or TouchEvent
   */


  PanelCarousel.prototype._removeMoveListeners = function _removeMoveListeners(_event) {
    if (_event.touches) {
      this._panelCarouselList.removeEventListener('touchmove', this._onMoveBound);
      this._panelCarouselList.removeEventListener('touchend', this._onMoveEndBound);
    } else {
      window.removeEventListener('mouseup', this._onMoveEndBound);
      window.removeEventListener('mousemove', this._onMoveBound);
    }
  };

  /**
   * Add bound event listeners
   */


  PanelCarousel.prototype._addEventListeners = function _addEventListeners() {
    window.addEventListener('scroll', this._onScrollBound);
    window.addEventListener('resize', this._onResizeBound);
    this.el.addEventListener('scroll', function (_event) {
      if (this.scrollLeft !== 0) {
        this.scrollLeft = 0;
      }
      _event.stopImmediatePropagation();
      _event.preventDefault();
      return false;
    });
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  PanelCarousel.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onScrollBound = this._onScroll.bind(this);
    this._onResizeBound = (0, _debounce2.default)(this._onResize.bind(this), 90);
  };

  /**
   * Store a reference to the tabs list, each tab and each panel.
   * Set which tab is active, or use the first.
   * @param {Element} el
   */


  PanelCarousel.prototype._cacheElements = function _cacheElements(el) {
    this.el = el;
    this._panelCarouselList = this.el.querySelector('.spark-panel-carousel__list');
    this._panelCarouselItems = this.el.querySelectorAll('.spark-panel-carousel__item');
    this.listTransitionDuration = window.getComputedStyle(this._panelCarouselList).getPropertyValue('transition-duration') || '800ms';
  };

  /**
   * Calculate the width of the Panel Carousel Items. widths are not static, may change based on screen size.
   */


  PanelCarousel.prototype._calcWidth = function _calcWidth() {
    this._panelCarouselWidth = (0, _outerWidth2.default)(this._panelCarouselList);
    this._panelCarouselItemsWidth = 0;

    for (var i = this._panelCarouselItems.length - 1; i > -1; i--) {
      this._panelCarouselItemsWidth += (0, _outerWidth2.default)(this._panelCarouselItems[i]);
      void this._panelCarouselItems.offsetWidth;
    }

    this.maxX = this._panelCarouselWidth - this._panelCarouselItemsWidth;

    // <= 0 means its part of a hidden div
    if (this._panelCarouselItemsWidth > this._panelCarouselWidth || this._panelCarouselWidth <= 0) {
      this._overflow = true;
      this.el.setAttribute('data-overflow', true);
    } else {
      this._overflow = false;
      this.el.removeAttribute('data-overflow');
    }
  };

  /**
   * Calculate the current Break point, update flags based on value
   *
   */


  PanelCarousel.prototype._calcBreakpoint = function _calcBreakpoint() {
    this.currentBreakpoint = (0, _breakpoint.get)(window.innerWidth);
    var breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
    var currentBreakIndex = breakpoints.indexOf(this.currentBreakpoint);
    var noCarouselBreakIndex = breakpoints.indexOf(this.noCarouselBreakPoint);
    var controlBreakIndex = breakpoints.indexOf(this.controlBreakPoint);

    // if not using the carousel, don't monitor touch events
    if (currentBreakIndex <= noCarouselBreakIndex && noCarouselBreakIndex !== -1) {
      this._useCarousel = false;
    } else {
      this._useCarousel = true;
    }

    if (currentBreakIndex <= controlBreakIndex) {
      this._useControls = false;
    } else {
      this._useControls = true;
    }
  };

  /**
   * Initialize the carousel slider.
   */


  PanelCarousel.prototype._initCarousel = function _initCarousel() {
    this.currentBreakpoint = (0, _breakpoint.get)(window.innerWidth);
    this._calcWidth();
    this._calcBreakpoint();
    this._addControls();
    this._showControls();
    this._addCarouselListeners();
  };

  /**
   * onScroll, if there is padding, if a carousel is in a fixed panel it will expand to fill 100%, need to watch if the isFixed class is applied and recalculate the width
   */


  PanelCarousel.prototype._onScroll = function _onScroll() {

    // if you have already done the calculation for the change in fixed state, don't recalc for every scroll event
    if (this.isFixed === (0, _hasClass2.default)(this.el, 'is-fixed-top')) {
      return;
    }

    if ((0, _hasClass2.default)(this.el, 'is-fixed-top')) {
      this.isFixed = true;
    } else {
      this.isFixed = false;
    }

    this._calcWidth();
    if (this._forwardLimit === true) {
      this._updateCarousel(this.maxX);
    }
  };

  /**
   * See if you are tabbing through the carousel. This is only attached when it's a tabbed variation.
   * @param  {KeyEvent} _event KeyEvent
   *
   */


  PanelCarousel.prototype._onKeyUp = function _onKeyUp(_event) {
    var tab = _event.target;

    if (_event.keyCode !== 9) {
      return;
    }

    // turn of transition for rapid tabbing.
    this._panelCarouselList.style['transition-duration'] = '0s';

    if (_event.shiftKey === true) {
      if ((0, _offset2.default)(tab).left <= (0, _outerWidth2.default)(this._backwards)) {
        this._backwards.click();
      } else if ((0, _offset2.default)(tab).left > (0, _outerWidth2.default)(this._panelCarouselList)) {
        this._forwardLimit = true;
        this._calcWidth();
        this._updateCarousel(this.maxX);
      }
    } else {
      if ((0, _offset2.default)(tab).left + (0, _outerWidth2.default)(tab) > (0, _outerWidth2.default)(this._panelCarouselList) - (0, _outerWidth2.default)(this._forwards)) {
        if (this._forwardLimit !== true) {
          this._forwards.click();
        }
      } else if ((0, _offset2.default)(tab).left + (0, _outerWidth2.default)(tab) < 0) {
        this._backwardLimit = true;
        this._updateCarousel(0);
      }
    }

    // turn on transition
    this._panelCarouselList.style['transition-duration'] = this.listTransitionDuration;
  };

  /**
   * Window resize event, keeps the carousel fresh... debounced from the listener. An event is passed to the method, but not used.
   */


  PanelCarousel.prototype._onResize = function _onResize() {
    this._calcWidth();
    this._calcBreakpoint();
    this._updateCarousel(0);
    this._calcWidth();
  };

  /**
   * Track touch end event, re-add transition
   * @param  {TouchEvent} _event touchmove
   */


  PanelCarousel.prototype._onMoveEnd = function _onMoveEnd(_event) {
    var xPosition = void 0;
    var screenX = this._startX;

    // touch event or mouse event
    if (_event.changedTouches) {
      screenX = _event.changedTouches[0].screenX;
      xPosition = screenX - this._startX + this._positionX;
    } else {
      screenX = _event.screenX;
      xPosition = screenX - this._startX + this._positionX;
    }

    this._moving = false;
    this._removeMoveListeners(_event);
    this._panelCarouselList.style['transition-duration'] = this.listTransitionDuration;

    // if difference is 0 then it was a click not a move;
    // a press looks like a move, this avoids it looking like a forward or backward click when it's a tab click
    if (this._useCarousel === false || Math.round(screenX - this._startX) === 0) {
      return;
    }
    if (xPosition > this._positionX) {
      this._backwards.click();
    } else {
      this._forwards.click();
    }
  };

  /**
   * Track touch move event. Moves the bar along with the touch movement.
   * @param  {TouchEvent} _event touchmove
   */


  PanelCarousel.prototype._onMove = function _onMove(_event) {

    // don't track if the move hasn't started
    if (this._moving === false) {
      return;
    }
    var xPosition = void 0;

    // test if has touch events or if it's a mouse event
    if (_event.changedTouches) {
      xPosition = _event.changedTouches[0].screenX - this._startX + this._positionX;
    } else {
      xPosition = _event.screenX - this._startX + this._positionX;
    }
    if (this._useCarousel === false) {
      return;
    }

    // the max is 0
    if (xPosition > 0) {
      xPosition = 0;
    }

    // maxX is a negative number, which is why this looks odd;
    if (xPosition < this.maxX) {
      xPosition = this.maxX;
    }

    // need to remove the transition or the move will try and transition rather than just going along with the move event.
    this._panelCarouselList.style['transition-duration'] = '0s';
    this._panelCarouselList.style.transform = 'translateX(' + xPosition + 'px)';
    if (_event) {
      _event.preventDefault();
    }
  };

  /**
   * Track touch start event. Calculates the maximum distance that you can scroll based on number of items and current position.
   * @param  {TouchEvent} _event touchmove
   */


  PanelCarousel.prototype._onMoveStart = function _onMoveStart(_event) {
    if (this._useCarousel === false) {
      return;
    }
    this._moving = true;
    this._addMoveListeners(_event);
    if (_event.changedTouches) {
      this._startX = _event.changedTouches[0].screenX;
      this._startY = _event.changedTouches[0].screenY;
    } else {
      this._startX = _event.screenX;
      this._startY = _event.screenY;
    }

    this._elRect = this.el.getBoundingClientRect();

    if (this._useControls === true) {
      this.maxX = -(this._panelCarouselItemsWidth - this._elRect.width + (0, _outerWidth2.default)(this._forwards) + (0, _outerWidth2.default)(this._backwards));
    } else {
      this.maxX = this._elRect.width - this._panelCarouselItemsWidth;
    }

    this.maxX = Math.round(this.maxX);
  };

  /**
   * Update the carousel position
   *
   * @param  {type} xPosition
   */


  PanelCarousel.prototype._updateCarousel = function _updateCarousel(xPosition) {
    if (xPosition === this.maxX) {
      this._forwardLimit = true;
    } else {
      this._forwardLimit = false;
    }

    if (xPosition === 0) {
      this._backwardLimit = true;
    } else {
      this._backwardLimit = false;
    }

    this._panelCarouselList.style.transform = "translateX(" + xPosition + "px)";
    this._positionX = xPosition;
    this._showControls();
  };

  /**
   * Identify which carousel button was clicked trigger correct arrow
   * @param  {clickEvent} _event click
   */


  PanelCarousel.prototype._onControlClick = function _onControlClick(_event) {
    _event.preventDefault();
    var button = _event.currentTarget;
    var xPosition = 0;
    if ((0, _hasClass2.default)(button, 'spark-panel-carousel__forwards')) {
      if (this.singleCarouselAdvance === false && this._useControls === true) {
        xPosition = this._setForwardClick(_event);
      } else {
        xPosition = this._singleForwardClick(_event);
      }
    } else if ((0, _hasClass2.default)(button, 'spark-panel-carousel__backwards')) {
      if (this.singleCarouselAdvance === false && this._useControls === true) {
        xPosition = this._setBackwardClick(_event);
      } else {
        xPosition = this._singleBackwardClick(_event);
      }
    } else {
      // not our click;
      return;
    }

    this._updateCarousel(Math.round(xPosition));
    _event.preventDefault();
  };

  /**
   * Advance the carousel one set.
   * @param  {clickEvent} _event click
   * @return {Number}
   */


  PanelCarousel.prototype._setForwardClick = function _setForwardClick(_event) {
    var button = _event.currentTarget;
    var buttonLeft = (0, _offset2.default)(button).left;
    var buttonWidth = (0, _outerWidth2.default)(button);
    var left = (0, _offset2.default)(this._panelCarouselItems[0]).left;
    var listBoxWidth = (0, _outerWidth2.default)(this._panelCarouselList);
    var max = buttonLeft;
    var xPosition = 0;
    var totalWidth = 0;

    this._backwardLimit = false;

    // recalculate the total width incase content was updated outside of resize.
    for (var i = 0; i < this._panelCarouselItems.length; i++) {
      totalWidth += (0, _outerWidth2.default)(this._panelCarouselItems[i]);
    }
    this.maxX = Math.round(-totalWidth + listBoxWidth);
    xPosition = this.maxX;

    for (var _i = 0; _i < this._panelCarouselItems.length; _i++) {
      if ((0, _offset2.default)(this._panelCarouselItems[_i]).left + (0, _outerWidth2.default)(this._panelCarouselItems[_i]) - buttonWidth > max) {
        xPosition = left - ((0, _offset2.default)(this._panelCarouselItems[_i]).left - buttonWidth);
        if (-xPosition > totalWidth - listBoxWidth) {
          xPosition = -totalWidth + listBoxWidth;
          this.maxX = Math.round(xPosition);
        }
        break;
      }
    }

    // if you can't go any further set the forwardLimit to true
    if (this.maxX === xPosition) {
      this._forwardLimit = true;
    }

    return xPosition;
  };

  /**
   * Reverse the carousel one set of items.
   * @param  {clickEvent} _event click
   * @return {Number}
   */


  PanelCarousel.prototype._setBackwardClick = function _setBackwardClick(_event) {
    var button = _event.currentTarget;
    var xPosition = (0, _outerWidth2.default)(this._panelCarouselList);
    this._forwardLimit = false;

    for (var i = this._panelCarouselItems.length - 1; i > -1; i--) {
      if ((0, _offset2.default)(this._panelCarouselItems[i]).left <= (0, _offset2.default)(this.el).left) {
        xPosition -= (0, _outerWidth2.default)(this._panelCarouselItems[i]);
      }
    }

    xPosition -= (0, _outerWidth2.default)(button);

    // if you can't go back any further, set to 0
    if (xPosition >= -(0, _outerWidth2.default)(button)) {
      xPosition = 0;
    }

    return xPosition;
  };

  /**
   * Shows or hides controls based on screen width, specified break points.
   */


  PanelCarousel.prototype._showControls = function _showControls() {
    // only need controls if there is an overflow and if you are still using the carousel__list
    if (this._overflow === true && this._useCarousel === true) {
      if (this._backwardLimit === true) {
        (0, _addClass2.default)(this._backwards, 'spark-panel-carousel__limit');
      } else {
        (0, _removeClass2.default)(this._backwards, 'spark-panel-carousel__limit');
      }

      if (this._forwardLimit === true) {
        (0, _addClass2.default)(this._forwards, 'spark-panel-carousel__limit');
      } else {
        (0, _removeClass2.default)(this._forwards, 'spark-panel-carousel__limit');
      }

      if (this._useControls === false) {
        (0, _addClass2.default)(this._backwards, 'spark-panel-carousel-no-controls');
        (0, _addClass2.default)(this._forwards, 'spark-panel-carousel-no-controls');
      } else {
        (0, _removeClass2.default)(this._backwards, 'spark-panel-carousel-no-controls');
        (0, _removeClass2.default)(this._forwards, 'spark-panel-carousel-no-controls');
      }
    } else {
      (0, _addClass2.default)(this._backwards, 'spark-panel-carousel__limit');
      (0, _addClass2.default)(this._forwards, 'spark-panel-carousel__limit');
    }
  };

  /**
   * Reverse the carousel one items.
   * @param  {clickEvent} _event click
   * @return {Number}
   */


  PanelCarousel.prototype._singleBackwardClick = function _singleBackwardClick(_event) {
    var button = _event.currentTarget;
    var buttonWidth = (0, _outerWidth2.default)(button);
    var buttonLeft = (0, _offset2.default)(button).left;
    var left = (0, _offset2.default)(this._panelCarouselList).left;
    var xPosition = 0;

    for (var i = this._panelCarouselItems.length - 1; i > 0; i--) {
      if ((0, _offset2.default)(this._panelCarouselItems[i]).left < buttonLeft + buttonWidth) {
        xPosition = left - (0, _offset2.default)(this._panelCarouselItems[i]).left + buttonWidth;

        // this is the margin of error so that if the browser size so it looks better at a browser size that may cause a button click to show a couple pixels
        if (xPosition > buttonWidth - 2) {
          xPosition = 0;
        }
        break;
      }
    }
    return xPosition;
  };

  /**
   * Advance the carousel one item.
   * @param  {clickEvent} _event click
   * @return {Number}
   */


  PanelCarousel.prototype._singleForwardClick = function _singleForwardClick(_event) {
    var button = _event.currentTarget;
    var xPosition = 0;
    var buttonWidth = (0, _outerWidth2.default)(button);
    var maxLeft = this._panelCarouselWidth + (0, _offset2.default)(this.el).left;
    var totalWidth = 0;

    if (this._useControls === true) {
      maxLeft -= buttonWidth;
    }

    xPosition = maxLeft;
    var adjustLeft = (0, _offset2.default)(this._panelCarouselItems[0]).left - (0, _offset2.default)(this.el).left;

    for (var i = 0; i < this._panelCarouselItems.length; i++) {
      totalWidth += (0, _outerWidth2.default)(this._panelCarouselItems[i]);
    }

    this.maxX = Math.round(-totalWidth + this._panelCarouselWidth);
    xPosition = this.maxX;

    for (var _i2 = 0; _i2 < this._panelCarouselItems.length; _i2++) {
      var itemRight = (0, _offset2.default)(this._panelCarouselItems[_i2]).left + (0, _outerWidth2.default)(this._panelCarouselItems[_i2]);

      if (itemRight > maxLeft) {
        xPosition = maxLeft - itemRight + adjustLeft;

        if (this._panelCarouselItems[_i2 + 1] === undefined) {
          if (this._useControls === true) {
            xPosition += buttonWidth;
          }
          this.maxX = Math.round(xPosition);
        }

        break;
      }
    }

    if (this.maxX === xPosition) {
      this._forwardLimit = true;
    }

    return xPosition;
  };

  return PanelCarousel;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


PanelCarousel.prototype._whitelistedParams = ['singleCarouselAdvance', 'noCarouselBreakPoint', 'controlBreakPoint', 'nextLabel', 'previousLabel', 'hasTabs'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
PanelCarousel.prototype.defaults = {
  el: null,
  singleCarouselAdvance: false,
  noCarouselBreakPoint: null,
  controlBreakPoint: 'xs',
  nextLabel: 'Show next',
  previousLabel: 'Show previous',
  _useControls: true,
  _panelCarouselItemsWidth: 0,
  _panelCarouselWidth: 0,
  _positionX: 0,
  _forwardLimit: false,
  _backwardLimit: true,
  _overflow: false,
  _hasTabs: false
};

exports.default = PanelCarousel;
module.exports = exports['default'];
//# sourceMappingURL=panel-carousel.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/components/panel-carousel.js
// module id = 800
// module chunks = 0